import { useLayoutEffect, type RefObject } from 'react';
import { fitStatisticReading } from '../render/statistic-fit';

/** Refit before painting, after fonts load, and when the reading's available width changes. */
export function useStatisticFit(ref: RefObject<HTMLElement | null>, minimum: number) {
  useLayoutEffect(() => {
    const container = ref.current;
    if (!container) return;
    let active = true;
    let frame = 0;
    const fit = () => { if (active) fitStatisticReading(container, minimum); };
    fit();
    void document.fonts?.ready.then(fit);
    const observer = new ResizeObserver(() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); });
    observer.observe(container);
    return () => { active = false; observer.disconnect(); cancelAnimationFrame(frame); };
  });
}
